module.exports = __webpack_public_path__ + "static/assets/68ba02360e77bf4665cf99bd98e4362a.svg";